import { Badge } from '../../ui/badge';
import { Users, FileText, Trophy, MapPin, Receipt } from 'lucide-react';
import PaymentStatusBadge from '../../PaymentStatusBadge';

/**
 * Composite key uses `type:id` so the same numeric id can't collide
 * across collections (e.g. an enrollment id matching a tournament id).
 */
export const invoiceKey = (inv) => `${inv.type}:${inv.id}`;

/**
 * Only pending/overdue rows are eligible for a reminder. Paid/void rows
 * get the checkbox hidden so admins can't accidentally select them.
 */
export const isReminderEligible = (inv) =>
  inv && (inv.status === 'pending' || inv.status === 'overdue');

const TYPE_BADGE_STYLES = {
  small_group: 'bg-teal-100 text-teal-800',
  enrollment: 'bg-blue-100 text-blue-800',
  tournament: 'bg-orange-100 text-orange-800',
  lane_booking: 'bg-purple-100 text-purple-800',
  manual: 'bg-emerald-100 text-emerald-800',
};

export const getTypeIcon = (type) => {
  switch (type) {
    case 'small_group': return <Users className="h-4 w-4" />;
    case 'enrollment': return <FileText className="h-4 w-4" />;
    case 'tournament': return <Trophy className="h-4 w-4" />;
    case 'lane_booking': return <MapPin className="h-4 w-4" />;
    case 'manual': return <Receipt className="h-4 w-4" />;
    default: return <Receipt className="h-4 w-4" />;
  }
};

export const getTypeBadge = (type, label) => (
  <Badge className={`${TYPE_BADGE_STYLES[type] || 'bg-slate-100 text-slate-800'} flex items-center gap-1`}>
    {getTypeIcon(type)}
    {label}
  </Badge>
);

export const getStatusBadge = (status) => <PaymentStatusBadge status={status} />;

/**
 * Pydantic 2 returns errors as arrays. Stringify cleanly for toasts.
 */
export const extractErrorMessage = (err, fallback = 'Request failed') => {
  const errorData = err?.response?.data;
  if (!errorData) return fallback;
  const detail = errorData.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || e.message || JSON.stringify(e)).join(', ');
  if (typeof detail === 'object') return detail.msg || detail.message || JSON.stringify(detail);
  if (typeof errorData === 'string') return errorData;
  return fallback;
};
